import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, themeColor, themeFontWeight, HorizontalRule, Hide } from '@elparking/components'
import { transparentize } from 'polished'
import styled from 'styled-components'

import { borderRadius } from 'commons/js/theme/styles'
import { FormattedMessage } from 'react-intl'
import Routes from 'commons/js/routes/routes'

const Background = styled(Box)`
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: auto;
    background-image: url('/images/login/bg.webp');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    box-shadow: 0px 2px 8px 0px ${themeColor('black')};
`

const Content = styled(Flex)`
    ${borderRadius}
    box-shadow: 0px 2px 8px 0px ${themeColor('black')};
    overflow-y: auto;
`

const Link = styled.a`
    font-weight: ${themeFontWeight('book')};
    color: ${themeColor('gray')};

    &:hover {
        color: ${themeColor('main')};
    }
`

const ContainerFlex = styled(Flex)`
    background: ${(props) => transparentize(0.1, themeColor('main')(props))};
`

const Container = ({ theme, brandImage, brandImageMobile, children, brandId, townId }) => (
    <Background>
        <ContainerFlex
          w='100%'
          minHeight={['100vh']}
          justifyContent='center'>
            <Content
              justifyContent='space-between'
              flexDirection='column'
              borderRadius={['0', '0.2em', '0.2em']}
              m={['0', '1em', '1em']}
              background='white'
              width='720px'
              maxWidth='100%'>
                <Box w='100%' m='0'>
                    <Box background={['main', 'main', 'transparent']} p='1em' pb={['1em', '1em', '0']}>
                        <Link rel='noopener noreferrer' href={townId ? Routes.finePortalWithFinePath({ townId, brandId }) : ''}>
                            <Hide xs sm md>
                                <img src={brandImage} alt={theme} height='100px' />
                            </Hide>
                            <Hide lg>
                                <img src={brandImageMobile} alt={theme} height='50px' />
                            </Hide>
                        </Link>
                    </Box>
                    <Box w='100%' mt='1em' fontWeight='regular' fontSize='small' fontColor='darkGray'>
                        <Box p='1em'>
                            {children}
                        </Box>
                    </Box>
                </Box>
                <Box w='100%' mb='1em'>
                    <HorizontalRule background='gray20' />
                    <Flex w='100%' justifyContent='space-between' flexWrap='wrap' mt='0.5em' textAlign='center' fontSize='xSmall' color='darkGray'>
                        <Box ph={['0.5em', '0', '0']} pb='0.5em' w={['100%', '100%', '33%']}>
                            <Link rel='noopener noreferrer' href={Routes.termsAndConditionsPath()} target='_blank'>
                                <FormattedMessage defaultMessage='Términos y condiciones' />
                            </Link>
                        </Box>
                        <Box ph={['0.5em', '0', '0']} pb='0.5em' w={['100%', '100%', '33%']}>
                            <Link rel='noopener noreferrer' href={Routes.cookiesPath()} target='_blank'>
                                <FormattedMessage defaultMessage='Privacidad y cookies' />
                            </Link>
                        </Box>
                        <Box ph={['0.5em', '0', '0']} pb='0.5em' w={['100%', '100%', '33%']}>
                            <Link rel='noopener noreferrer' href={Routes.zendeskPath()} target='_blank'>
                                <FormattedMessage defaultMessage='Ayuda' />
                            </Link>
                        </Box>
                    </Flex>
                </Box>
            </Content>
        </ContainerFlex>
    </Background>
)

Container.propTypes = {
    theme: PropTypes.string.isRequired,
    brandImage: PropTypes.string.isRequired,
    brandImageMobile: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    townId: PropTypes.number,
    brandId: PropTypes.number.isRequired,
}

export default Container
